import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Styles from '../../../GeneralUI/Styles';
import { Paper, InputLabel, Grid } from '@material-ui/core';
import Buttoncontrol from "../../../GeneralUI/Buttoncontrol";
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { TextField, Button } from '@material-ui/core';
import { SnackbarProvider, withSnackbar } from 'notistack';
import { errorSetter, combineStyles } from '../../../../Libs/';
import AutoComplete from '../../../GeneralUI/AutoComplete';
import PSelect from '../../../GeneralUI/PSelect'
import Utils from '../../../../Libs/utils';


const styles = theme => ({
  button: {
    margin: theme.spacing(),
  },
  input: {
    display: 'none',
  }
});

class EnviarDian extends Component {
  constructor(props) {
    super(props);
    this.setErrors = errorSetter.setErrors.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    data: [],
    fields: {
      facturaTipoEnvio: null,
      facturaCodigo: null,
      facturaFechaInicial:null,
      facturaFechaFinal:null
    },
    responseForm: { Message: '', typeMessage: '' },
    formValidations: {view: []},
    formErrors: {    }
  };

  componentDidMount() {
    const params = this.props.match.params;
    this.message('info', 'TRAS EJECUTAR EL PROCESO, POR FAVOR REVISE EL AVANCE EN EL VISOR DIAN. ESTO PUEDE TARDAR VARIOS MINUTOS.'); 
    if (!params.id) {
      return;
    }
  }

  handleSeguir = () => {
    alert('Seguimiento registrado.');
  }

  handleChange = (event) => {
    let { fields } = this.state;
    if (event.target.type === 'time') {
      fields[event.target.id] = event.target.value;
    } else if (event.target.type === 'number') {
      fields[event.target.id] = event.target.value;
    } else {
      fields[event.target.id] = event.target.value.toUpperCase();
    }

    if (fields[event.target.id] === '') {
      fields[event.target.id] = null;
    }

    this.setState({ fields });
  }

  save = (response) => {

    let newState={
      data: response.data,
      responseForm: response.responseForm
    };

    this.setState(newState);

    this.message(newState.responseForm['typeMessage'], newState.responseForm['Message']);
  }

  message = (type, message) => {
    this.props.enqueueSnackbar(message, { variant: type });
  }

  messageValidation = (type, message) => {
    this.message(type, message);
  }

  validaData = () => {
    let isvalid = true, message = 'El registro no ha sido guardado.', type = "warning",res,fechados,fechauno;

    if ((this.state.fields.facturaTipoEnvio == null || !String(this.state.fields.facturaTipoEnvio).trim())) {
      message = "Debe diligenciar El tipo de envio.";
      isvalid = false;
    }else{
      if (this.state.fields.facturaTipoEnvio === 'MASIVO'){
        res = (this.state.fields.facturaFechaInicial || '').split("-");
        fechauno = new Date(res[0], res[1] - 1, res[2], 0, 0, 0);
    
        res = (this.state.fields.facturaFechaFinal || '').split("-");
        fechados = new Date(res[0], res[1] - 1, res[2], 0, 0, 0);

        if ((!Utils.onlyComparateDate(fechauno, fechados)) || 
        (this.state.fields.facturaFechaInicial == null || 
        !String(this.state.fields.facturaFechaInicial).trim()) || 
        (this.state.fields.facturaFechaFinal == null || 
        !String(this.state.fields.facturaFechaFinal).trim())) {
          message = "Verifique LAS FECHAS.";
          isvalid = false;
        }
      }else{
        if ((this.state.fields.facturaCodigo === null || !String(this.state.fields.facturaCodigo).trim())) {
          message = "Debe diligenciar El campo factura.";
          isvalid = false;     
        }
      }
    }




    if (!isvalid) {
      this.message(type, message);
    }
    return isvalid;
  }

  render() {
    const { classes } = this.props;

    return (

      <Paper elevation={5} className={classes.mainPaper}>
        <form className={this.props.form} onSubmit={e => e.preventDefault()}>

          <Grid container spacing={3} className={classes.gridForm}>
            <InputLabel className={classes.tittleLabelForm}>
              Enviar Dian
            </InputLabel>
          </Grid>

          
          <Grid container spacing={2}>  
            <Grid item xs={3} className={this.props.classes.gridForm}>
                <PSelect
                  id="facturaTipoEnvio"
                  useChildren={true}
                  value={this.state.fields["facturaTipoEnvio"]}
                  onChange={this.handleChange}
                  namelabel="Tipo Envio"
                >
                  <option value="PUNTUAL">PUNTUAL</option>
                  <option value="MASIVO">MASIVO</option>
                </PSelect>
              </Grid>       
          </Grid>

          <Grid container spacing={4}>
          <Grid item xs={3} className={classes.gridForm}>
              <AutoComplete
                id="facturaCodigo"
                tableName='vw_factura_visor_dian'
                fields={['FACTURA_CODIGO', 'RESOLUCION', 'CLIENTE']}
                aliases={[{ value: 'ID', size: 4 },  { value: 'RESOLUCION', size: 3 },  { value: 'Cliente', size: 5 }]}
                size='xl'
                primaryField='FACTURA_CODIGO'
                searchField='RESOLUCION'
                isView={true}
                placeHolder='Factura'
                onSelect={this.handleChange}
                value={this.state.fields["facturaCodigo"]}
              />
            </Grid>
            <Grid item xs={3} className={classes.gridForm}>
              <TextField
                id="facturaFechaInicial"
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["facturaFechaInicial"]}
                type="date"
                label="Fecha Inicial"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={3} className={classes.gridForm}>
              <TextField
                id="facturaFechaFinal"
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["facturaFechaFinal"]}
                type="date"
                label="Fecha Final"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </form>

        <div id='buttonContainer'>
          <Buttoncontrol
            saveData={this.state}
            saveDataValidation={this.state.fields}
            moduleName='factura'
            save={this.save}
            validaData={this.validaData}
            messageValidation={this.messageValidation}
            primaryFields={['facturaCodigo']}
            formValidations={this.state.formValidations}
            errorHandler={this.setErrors}
            url='/processes/enviar_dian'
            isFormLite={true}
          />
        </div>

      </Paper>
    );
  }
}



EnviarDian.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
};

const MyApp = withRouter(withSnackbar(withStyles(combineStyles(styles, Styles))(EnviarDian)));

function IntegrationNotistack() {
  return (
    <SnackbarProvider key={6} maxSnack={1}
      action={[
        <Button key={6} variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}
    >
      <MyApp />
    </SnackbarProvider>
  );
}


export default IntegrationNotistack;